import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  position: "relative",
}));

export const BeforeIconBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  left: 10,
  top: 12,

  "& > svg": {
    fill: theme.palette.textMuted,
    cursor: "pointer",
  }
}));

export const IconBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  right: 10,
  top: 12,

  "& > svg": {
    fill: theme.palette.textMuted,
    cursor: "pointer",
  }
}));

export const StyledInput = styled("input")(({ theme, $hasBeforeIcon, $hasAfterIcon }) => ({
  ...theme.paddings(10, $hasAfterIcon ? 30 : 10, 10, $hasBeforeIcon ? 30 : 10),
  width: "100%",
  border: `1px solid ${theme.palette.borderDefault}`,
  borderRadius: 0,
  outline: "none",
}));
